import PropTypes from "prop-types";
import React, { useState } from "react";

import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const PasswordInput = ({ setPassword, label = "Password", ...inputProps }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextField
      onChange={(e) => setPassword(e.target.value)}
      required
      fullWidth
      label={label}
      type={showPassword ? "text" : "password"}
      autoComplete="new-password"
      InputProps={{
        endAdornment: (
          <IconButton
            aria-label="toggle password visibility"
            onClick={() => setShowPassword((prev) => !prev)}
            onMouseDown={(e) => e.preventDefault()}
            edge="end"
          >
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        ),
      }}
      {...inputProps}
    />
  );
};

PasswordInput.propTypes = {
  label: PropTypes.string,
  setPassword: PropTypes.func,
};

export default PasswordInput;
